import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "order-details-modal-body" }
const _hoisted_2 = { class: "upper-body" }
const _hoisted_3 = { class: "changing-items" }
const _hoisted_4 = { class: "date-title" }
const _hoisted_5 = { class: "vertical-container" }
const _hoisted_6 = { class: "date-title" }
const _hoisted_7 = { class: "vertical-container" }
const _hoisted_8 = { class: "vertical-container" }
const _hoisted_9 = {
  key: 0,
  class: "order-checkbox-show-details order-checkbox-readonly"
}
const _hoisted_10 = ["checked"]
const _hoisted_11 = { for: "showDetailsOnInvoice" }
const _hoisted_12 = { class: "lower-body" }
const _hoisted_13 = { class: "order-line-header role" }
const _hoisted_14 = { class: "order-line-header quantity" }
const _hoisted_15 = { class: "order-line-header hourly-rate" }
const _hoisted_16 = { class: "order-line-header subtotal" }
const _hoisted_17 = { class: "total" }
const _hoisted_18 = { class: "total-number" }
const _hoisted_19 = {
  key: 0,
  class: "order-checkbox-agreement"
}
const _hoisted_20 = { for: "legalNoticeAgreement" }
const _hoisted_21 = {
  key: 1,
  class: "approval-error"
}
const _hoisted_22 = {
  key: 2,
  class: "loading apollo"
}
const _hoisted_23 = { class: "orders-to-reject" }
const _hoisted_24 = { class: "header" }
const _hoisted_25 = { class: "orders-to-reject-header title" }
const _hoisted_26 = { class: "orders-to-reject-header date" }
const _hoisted_27 = { class: "orders-to-reject-header status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormItem = _resolveComponent("FormItem")!
  const _component_OrderLine = _resolveComponent("OrderLine")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_EntitiesList = _resolveComponent("EntitiesList")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.recurringOrder)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _ctx.closeModal,
          size: "lg-fixed",
          class: "order-details"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.recurringOrder.title), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_FormItem, {
                    input: _ctx.recurringOrder.title,
                    label: _ctx.t(`labels.order.title`),
                    name: "order-title",
                    readOnly: true
                  }, null, 8, ["input", "label"]),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("labels.recurringOrder.firstMonth")) + " : ", 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_FormItem, {
                      input: _ctx.recurringOrder.startDate.split('-')[0],
                      label: _ctx.t(`labels.order.year`),
                      name: "order-year",
                      readOnly: true
                    }, null, 8, ["input", "label"]),
                    _createVNode(_component_FormItem, {
                      input: 
                  _ctx.months[parseInt(_ctx.recurringOrder.startDate.split('-')[1], 10)]
                ,
                      label: _ctx.t(`labels.order.month`),
                      name: "order-month",
                      readOnly: true
                    }, null, 8, ["input", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t("labels.recurringOrder.lastMonth")) + " : ", 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_FormItem, {
                      input: _ctx.recurringOrder.endDate.split('-')[0],
                      label: _ctx.t(`labels.order.year`),
                      name: "order-year",
                      readOnly: true
                    }, null, 8, ["input", "label"]),
                    _createVNode(_component_FormItem, {
                      input: 
                  _ctx.months[parseInt(_ctx.recurringOrder.endDate.split('-')[1], 10)]
                ,
                      label: _ctx.t(`labels.order.month`),
                      name: "order-month",
                      readOnly: true
                    }, null, 8, ["input", "label"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_FormItem, {
                    input: _ctx.t(`paymentOptionLabels.${_ctx.recurringOrder.paymentOption}`),
                    label: _ctx.t(`labels.order.paymentOption`),
                    name: "order-payment-options",
                    readOnly: true
                  }, null, 8, ["input", "label"]),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fill-empty-space" }, null, -1)),
                  _createVNode(_component_FormItem, {
                    input: _ctx.recurringOrder.company.name,
                    label: _ctx.t(`labels.order.company`),
                    name: "order-company",
                    readOnly: true
                  }, null, 8, ["input", "label"])
                ]),
                (_ctx.hasAdminAccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        id: "showDetailsOnInvoice",
                        checked: !_ctx.recurringOrder.showDetailsOnInvoice
                      }, null, 8, _hoisted_10),
                      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t(`labels.order.showDetailsOnInvoice`)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t("labels.order.roles")), 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t("labels.order.quantity")), 1),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.t("labels.order.hourlyRate")), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.t("labels.order.subtotal")), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recurringOrder.orderLines, (orderLine, index) => {
                    return (_openBlock(), _createBlock(_component_OrderLine, {
                      key: index,
                      projectRoleName: orderLine.projectRoleName,
                      hourlyRate: orderLine.hourlyRate,
                      subtotal: _ctx.subtotals[index],
                      "onUpdate:subtotal": ($event: any) => ((_ctx.subtotals[index]) = $event),
                      quantity: orderLine.quantity,
                      "onUpdate:quantity": ($event: any) => ((orderLine.quantity) = $event),
                      unit: orderLine.unit,
                      "onUpdate:unit": ($event: any) => ((orderLine.unit) = $event),
                      readOnly: true
                    }, null, 8, ["projectRoleName", "hourlyRate", "subtotal", "onUpdate:subtotal", "quantity", "onUpdate:quantity", "unit", "onUpdate:unit"]))
                  }), 128))
                ]),
                _createElementVNode("p", _hoisted_17, [
                  _createTextVNode(_toDisplayString(_ctx.t("labels.order.total")) + " ", 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatPrice(_ctx.total)), 1)
                ]),
                _createVNode(_component_FormItem, {
                  input: _ctx.recurringOrder.notes,
                  "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recurringOrder.notes) = $event)),
                  label: _ctx.t(`labels.order.notes`),
                  name: "order-notes",
                  readOnly: true,
                  "input-type": "textArea"
                }, null, 8, ["input", "label"]),
                _createVNode(_component_FormItem, {
                  input: _ctx.recurringOrder.legalNotice,
                  "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recurringOrder.legalNotice) = $event)),
                  label: _ctx.t(`labels.order.legalNotice`),
                  name: "order-legalNotice",
                  readOnly: true,
                  "input-type": "textArea"
                }, null, 8, ["input", "label"])
              ])
            ]),
            (
          _ctx.recurringOrder.isFirstOrder &&
          !_ctx.hasAdminAccess &&
          ['to_validate', 'late_approval'].includes(_ctx.recurringOrder.status)
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "legalNoticeAgreement",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.legalNoticeAgreement) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.legalNoticeAgreement]
                  ]),
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t(`labels.order.legalNoticeAgreement`)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showApproveValidation)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.t("legalNoticeAgreementError")), 1))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.t("loading")), 1))
              : _createCommentVNode("", true)
          ]),
          footer: _withCtx(() => [
            (
          !_ctx.readOnly &&
          !_ctx.hasAdminAccess &&
          ['to_validate', 'late_approval'].includes(_ctx.recurringOrder.status)
        )
              ? (_openBlock(), _createBlock(_component_BasicButton, {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.approveRecurringOrder()), ["prevent"])),
                  disabled: _ctx.loadingAction,
                  class: "order-details-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("buttons.order.approve")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (
          !_ctx.readOnly &&
          _ctx.hasAdminAccess &&
          ['draft'].includes(_ctx.recurringOrder.status)
        )
              ? (_openBlock(), _createBlock(_component_BasicButton, {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.sendRecurringOrder()), ["prevent"])),
                  disabled: _ctx.loadingAction,
                  class: "order-details-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("buttons.order.send")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (
          !_ctx.readOnly &&
          _ctx.hasAdminAccess &&
          ['draft', , 'to_validate', 'late_approval'].includes(
            _ctx.recurringOrder.status,
          )
        )
              ? (_openBlock(), _createBlock(_component_BasicButton, {
                  key: 2,
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.deleteOrder()), ["prevent"])),
                  disabled: _ctx.loadingAction,
                  class: "order-details-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("buttons.order.delete")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (
          !_ctx.readOnly &&
          _ctx.hasAdminAccess &&
          ['approved'].includes(_ctx.recurringOrder.status)
        )
              ? (_openBlock(), _createBlock(_component_BasicButton, {
                  key: 3,
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openConfirmModalAndGetOrdersToReject()), ["prevent"])),
                  disabled: _ctx.loadingAction,
                  class: "order-details-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("buttons.order.cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isConfirmModalVisible)
      ? (_openBlock(), _createBlock(_component_ConfirmModal, {
          key: 1,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeConfirmModal())),
          onNo: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeConfirmModal())),
          onYes: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelOrder())),
          question: _ctx.t('validateCancel', { title: _ctx.recurringOrder.title })
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.t("ordersToReject")) + " :", 1),
            _createElementVNode("ul", _hoisted_23, [
              _createElementVNode("li", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.t("labels.order.title")), 1),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t("labels.order.month")), 1),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.t("labels.order.status")), 1)
              ]),
              _createVNode(_component_EntitiesList, {
                elements: _ctx.ordersToReject,
                hasIcon: false,
                emptySpace: _ctx.t('empty.order')
              }, null, 8, ["elements", "emptySpace"])
            ])
          ]),
          _: 1
        }, 8, ["question"]))
      : _createCommentVNode("", true)
  ], 64))
}